<template>
    <div class="embed-section">
        <div class="title">
            <p class="h4 title-content">
                {{ title }}
            </p>
            <slot name="after-title" />
            <copy-handler
                v-slot:default="{
                    tooltipVisible,
                }"
                :element="`.${name}-button`"
                :value="script"
                class="copy-button"
            >
                <button :class="`functional-button is-dark is-bold ${name}-button`">
                    <i class="far fa-copy" />
                    <span>Copy</span>
                    <base-tooltip
                        :class="{ active: tooltipVisible }"
                    >
                        Copied!
                    </base-tooltip>
                </button>
            </copy-handler>
        </div>

        <div class="embed">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <code v-html="escapedScript" />
        </div>
    </div>
</template>
<script>
// External dependencies.
import { escape, kebabCase } from 'lodash';
// Internal dependencies.
import CopyHandler from '@/components/CopyHandler';

export default {
    components: {
        CopyHandler,
    },

    props: {
        title: {
            required: true,
            type: String,
        },
        script: {
            required: true,
            type: String,
        },
    },

    computed: {
        /**
         * Returns name of the section.
         *
         * @returns {string} Name of section.
         */
        name() {
            return kebabCase(this.title);
        },

        /**
         * Returns escaped version of script.
         *
         * @returns {string} Escaped script.
         */
        escapedScript() {
            return escape(this.script);
        },
    },
};
</script>
